module.exports = __webpack_public_path__ + "static/media/arrow-square-up.2694a541.svg";